import { Link } from 'react-router-dom';
import { useSettings } from '../SettingsContext';
import React, { useEffect, useState } from "react";
import axios from "axios";
import NewsLetter from "./NewsLetter";

const Footer = () => {
    const setting = useSettings();
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [visaTypes, setVisaTypes] = useState([]);

    useEffect(() => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_VISA_TYPE;

        const cacheKey = "visaTypes";
        const cacheTimestampKey = "visaTypesTimestamp";
        const cacheExpiry = 30 * 60 * 1000; // 30 minutes

        const cachedData = localStorage.getItem(cacheKey);
        const cachedTimestamp = localStorage.getItem(cacheTimestampKey);

        if (cachedData && cachedTimestamp && (Date.now() - parseInt(cachedTimestamp, 10)) < cacheExpiry) {
            setVisaTypes(JSON.parse(cachedData));
        } else {
            axios.get(`${apiBaseUrl}${Url}`)
                .then(response => {
                    setVisaTypes(response.data);
                    localStorage.setItem(cacheKey, JSON.stringify(response.data));
                    localStorage.setItem(cacheTimestampKey, Date.now().toString());
                })
                .catch(error => console.error("Error fetching API", error));
        }
    }, []);

    return (
        <footer className="footer-area" style={{ backgroundColor: '#201d1d' }}>
            <div className="footer-shape">
                <img src="assets/img/shape/01.png" alt=""/>
            </div>
            <div className="footer-widget">
                <div className="container">
                    <div className="footer-widget-wrap pt-100 pb-80">
                        <div className="row g-4">
                            <div className="col-lg-5">
                                <div className="footer-widget-box text-center about-us">
                                    <Link className="footer-logo" to={'/'}>
                                        <img src={`${backendBaseUrl}${setting?.icon}`} alt="logo" style={{ width: '100px' }} />
                                    </Link>
                                    <h5 className={'fw-bold text-white'}>{setting?.website_name}</h5>
                                    <ul className="footer-social">
                                        {setting?.facebook && (
                                            <li><a href={setting.facebook} target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a></li>
                                        )}
                                        {setting?.youtube && (
                                            <li><a href={setting.youtube} target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a></li>
                                        )}
                                        {setting?.instagram && (
                                            <li><a href={setting.instagram} target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
                                        )}
                                        {setting?.linkedIn && (
                                            <li><a href={setting.linkedIn} target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in"></i></a></li>
                                        )}
                                        {setting?.tiktok && (
                                            <li><a href={setting.tiktok} target="_blank" rel="noopener noreferrer"><i className="fab fa-tiktok"></i></a></li>
                                        )}
                                        {setting?.twitter && (
                                            <li><a href={setting.twitter} target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a></li>
                                        )}
                                    </ul>
                                    <NewsLetter />
                                </div>
                            </div>
                            <div className="col-6 col-lg-2">
                                <div className="footer-widget-box list">
                                    <h4 className="footer-widget-title">লিংকে ক্লিক করুন</h4>
                                    <ul className="footer-list">
                                        <li><Link className="nav-link" to={'/'}><i className="far fa-angle-double-right"></i> হোম</Link></li>
                                        <li><Link className="nav-link" to={'/about-us'}><i className="far fa-angle-double-right"></i> আমাদের সম্পর্কে</Link></li>
                                        <li><Link className="nav-link" to={'/visa'}><i className="far fa-angle-double-right"></i> ভিসা</Link></li>
                                        <li><Link className="nav-link" to={'/blogs'}><i className="far fa-angle-double-right"></i> ব্লগ</Link></li>
                                        <li><Link className="nav-link" to={'/contact-us'}><i className="far fa-angle-double-right"></i> যোগাযোগ</Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-6 col-lg-2">
                                <div className="footer-widget-box list">
                                    <h4 className="footer-widget-title">ভিসার ধরণ</h4>
                                    <ul className="footer-list">
                                        {visaTypes.map((visaType, index) => (
                                            <li key={index}>
                                                <Link className="text-decoration-none" to={`/visa/${visaType.slug}`}>
                                                    <i className="far fa-angle-double-right"></i> {visaType?.name}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="footer-widget-box">
                                    <h4 className="footer-widget-title">Get In Touch</h4>
                                    <ul className="footer-contact">
                                        <li>
                                            <div className="icon"><i className="far fa-location-dot"></i></div>
                                            <div className="content">
                                                <h6>Our Address</h6>
                                                <p>{setting?.address || ''}</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="icon"><i className="far fa-phone"></i></div>
                                            <div className="content">
                                                <h6>Call Us</h6>
                                                <a className={"nav-link"}>{setting?.footer_phone || ''}</a>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="icon"><i className="far fa-envelope"></i></div>
                                            <div className="content">
                                                <h6>Mail Us</h6>
                                                <a href={`mailto:${setting?.email || ''}`}>
                                                    <span className="__cf_email__">{setting?.email || ''}</span>
                                                </a>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="copyright">
                    <div className="row">
                        <div className="col-12 text-center">
                            <p className="copyright-text">
                                {setting?.footer_copyright || ''}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
